import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';

import ChatMessage from '../../../../Model/ChatMessage';

import { AttachmentType } from '../../../../utils/attachments';

import AudioMessageAttachment from './components/Audio/AudioMessageAttachment';
import FileMessageAttachment from './components/File/FileMessageAttachment';
import VideoMessageAttachment from './components/Video/VideoMessageAttachment';
import ImageMessageAttachment from './components/Image/ImageMessageAttachment';
import GenericAttachment from './components/GenericAttachment/GenericAttachment';

import {
  ReplyMessageContainer,
  ReplyDescription,
  ReplyMessageContent,
  ReplyMessage,
  StyledCloseIcon,
  ReplyMessageInternalTextWarning,
  AttachmentsLine,
} from './styles';
import texts from './texts.json';

const MediaComponents = {
  [AttachmentType.AUDIO]: AudioMessageAttachment,
  [AttachmentType.FILE]: FileMessageAttachment,
  [AttachmentType.IMAGE]: ImageMessageAttachment,
  [AttachmentType.VIDEO]: VideoMessageAttachment,
};

const ReplyMessagePreview = ({
  quotedMessage,
  setQuotedMessage,
}) => {
  const getAttachmentComponents = useCallback((attachmentList = []) => (
    attachmentList.map((attachment) => {
      const Component = MediaComponents[attachment.type];
      return (
        <GenericAttachment
          key={uuid.v4()}
          attachment={attachment.assetPath}
          AttachmentComponent={Component}
        />
      );
    })
  ), []);

  const hasAttachments = quotedMessage.attachments?.length > 0;

  return (
    <ReplyMessageContainer>
      <StyledCloseIcon onClick={() => setQuotedMessage()} />
      <ReplyDescription>{texts.replyingTo}</ReplyDescription>
      {hasAttachments && (
        <AttachmentsLine>{getAttachmentComponents(quotedMessage.attachments)}</AttachmentsLine>
      )}
      {quotedMessage.internalText && (
        <ReplyMessageInternalTextWarning>
          {texts.hasInternalText}
        </ReplyMessageInternalTextWarning>
      )}
      <ReplyMessageContent>
        <ReplyMessage>
          {quotedMessage.text || `[${texts.noText}]`}
        </ReplyMessage>
      </ReplyMessageContent>
    </ReplyMessageContainer>
  );
};

ReplyMessagePreview.propTypes = {
  quotedMessage: PropTypes.oneOfType([
    PropTypes.instanceOf(ChatMessage),
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      userId: PropTypes.string,
      userName: PropTypes.string,
      attachments: PropTypes.array,
      internalText: PropTypes.string,
    }),
  ]).isRequired,
  setQuotedMessage: PropTypes.func.isRequired,
};

export default ReplyMessagePreview;
